import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DispalyAnimationState,
  TDispalyAnimationFpsState,
} from "./VirtualKoteachTypes";

export interface IVKoteachState {
  display_animation_state: keyof typeof DispalyAnimationState | null;
  display_animation_fps: TDispalyAnimationFpsState;
}

const initialState: IVKoteachState = {
  display_animation_state: "sleeping",
  display_animation_fps: 15,
};
// action: PayloadAction<HomeLayout>
export const virtualKoteachSlice = createSlice({
  name: "virtualKoteach",
  initialState,
  reducers: {
    setDisplayState: (
      state,
      action: PayloadAction<keyof typeof DispalyAnimationState | null>
    ) => {
      state.display_animation_state = action.payload;
    },
    setDispalyAnimationFpsState: (
      state,
      action: PayloadAction<TDispalyAnimationFpsState>
    ) => {
      state.display_animation_fps = action.payload;
    },
  },
});

export const { setDisplayState, setDispalyAnimationFpsState } =
  virtualKoteachSlice.actions;

export default virtualKoteachSlice.reducer;
